import React, { ReactNode } from 'react';
import './TextPage.scss'

interface TextPage {
    text: string | ReactNode;
    size?: number,
    color?: string,
    style?: object
}

const TextPage = ({
    text,
    size = 14,
    color = '',
    style = {}
}: TextPage): JSX.Element => {
    return (
        <p className={`text-page`}
            style={{ 
                fontSize: `${size}px`,
                color: color || '',
                ...style
             }}
        >{text}</p>
    )
};

export { TextPage };